export default __webpack_public_path__ + "static/media/oatmeal.9f8de0b4.jpg";